import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { API_URL_V3 } from "../api";
import { APIError, APIResponse, post } from "../api";

function useLoanRepayment(
  options?: MutationOptions<
    APIResponse<any>,
    APIError,
    {
      loan_id: string;
      repayment_amount: number;
      is_termination?: boolean;
    }
  >
) {
  const client = useQueryClient();
  const {
    isLoading: repaying,
    isError: isRepayError,
    error: repayError,
    mutate: repay,
    data: repayData,
  } = useMutation(
    (variables) => {
      return post(API_URL_V3 + "/alert/transaction/loan/repay", variables, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    {
      ...options,
      onSettled(data, error, variables, context) {
        client.refetchQueries("transactionHistory");
        client.refetchQueries("profile");
        client.refetchQueries("quick-loans");
        options?.onSettled?.(data, error, variables, context);
      },
    }
  );

  return {
    repay,
    isRepayError,
    repayData,
    repayError,
    repaying,
  };
}

export default useLoanRepayment;
